import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "./recentChat.css";
import socket from "../../helpers/socket";
import Avatar from "react-avatar";
import fetchApi from "../../common/fetchApi";
import api from "../../routes/api";
import toast, { Toaster } from "react-hot-toast";
import SocketContext from "../../socketContext/socketContext";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  TumblrShareButton,
  VKShareButton,
  PinterestShareButton,
  RedditShareButton,
  EmailShareButton,
  WeiboShareButton,
} from "react-share";
import {
  FacebookIcon,
  FacebookMessengerIcon,
  LinkedinIcon,
  TwitterIcon,
  PinterestIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  VKIcon,
  TelegramIcon,
  EmailIcon,
  WeiboIcon,
} from "react-share";

const withRouter = Component => props => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  return (
    <Component
      {...props}
      location={location}
      navigate={navigate}
      params={params}
    />
  );
};

function RecentChat(props) {
  // constructor(props){
  // super(props);
  // state={
  // 	users:[],
  // 	recentChats:[]
  // }
  // }
  const [state, setState] = useState({
    users: [],
    recentChats: [],
  });
  const userList = useContext(SocketContext);
  //console.log("=====> user list", userList);

  const navigate = useNavigate();
  let isOnline;
  let arr = [];
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user != null && user.data && user.data.success) {
      getRecentChatList();
      // setTimeout(() => {
      // 	socketJoin();
      // 	getUser();
      // },1000)
    } else {
    }
  }, []);

  // socketJoin = async () => {
  // 	const user=JSON.parse(localStorage.getItem('user'));

  // 	if (user!=null && user.data.success) {
  // 		let users = {
  // 			firstname: user.data.data.firstname,
  // 			lastname: user.data.data.lastname,
  // 			userId: user.data.data.id,
  // 			email: user.data.data.email,
  // 			image: (Array.isArray(user.data.data.image) && user.data.data.image.length) == 0 ? "" :user.data.data.image[0].url,
  // 			username: user.data.data.username,
  // 			createdAt: Date.now()

  // 		  };

  // 		  socket.emit('addUser', users);
  // 		  getUser();

  // 	}

  //   }
  //   getUser = async () => {
  // 	  const user=JSON.parse(localStorage.getItem('user'));
  // 	socket.on('getUsers', (data) => {
  // 	 //console.log("user data ===>",data)
  // 	  data.forEach(element => {
  // 		  if (element.userId !=  user.data.data.id) {
  // 		        arr.push(element);
  // 		}
  // 	  });
  // 	  let userData = arr.filter((item, index, objects) => {
  // 		if (index === 0) {
  // 			return item;
  // 		} else if (item.userId !== objects[index - 1].userId) {
  // 			return item;
  // 		}

  // 	});
  // 	// //console.log(userData,"<===data")
  // 	  setState({ users: userData});
  // 	});
  //   }
  const getRecentChatList = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await fetchApi({
      url: api.coversationList,
      method: "POST",
      body: {
        userId: user.data.data.id,
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });

    if (result && result.data && result.data.success) {
      const data = await match(result.data.data, userList);
      //console.log(data, "<===data");
      setState((prev) => ({ ...prev, recentChats: data }));
    } else {
      setState((prev) => ({
        ...prev,
        recentChats: [],
      }));
    }
  };
  const match = async (arr1, arr2) => {
    for (let i = 0; i < arr1.length; i++) {
      for (let j = 0; j < arr2.length; j++) {
        if (arr1[i].senderId == arr2[j].userId) {
          arr1[i].isOnline = true;
        } else {
          arr1[i].isOnline = false;
        }
      }
    }
    return arr1;
  };
  const seenMsg = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await fetchApi({
      url: api.seenMsg,
      method: "POST",
      body: {
        userId: id,
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result && result.data && result.data.success) {
      getRecentChatList();
      toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    } else {
      toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    }
  };

  const chat = (id) => {
    navigate(`/user-chat/${id}`);
  };

  return (
    <>
      {" "}
      <div className="chat-right-box">
        <div style={{ fontSize: "10px" }}>Invite Friends</div>
        <div style={{ marginTop: "5px", marginBottom: "5px" }}>
          <TwitterShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            title={"Please, join and follow me on Fonolive"}
          >
            <TwitterIcon size={32} round={true} />
          </TwitterShareButton>
          <FacebookShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            quote={"Please, join and follow me on Fonolive"}
          >
            <FacebookIcon size={32} round={true} />
          </FacebookShareButton>
          <RedditShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            title={"Please, join and follow me on Fonolive"}
          >
            <RedditIcon size={32} round={true} />
          </RedditShareButton>
          <LinkedinShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            title={"Please, join and follow me on Fonolive"}
          >
            <LinkedinIcon size={32} round={true} />
          </LinkedinShareButton>
          <TelegramShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            title={"Please, join and follow me on Fonolive"}
          >
            <TelegramIcon size={32} round={true} />
          </TelegramShareButton>
          <WeiboShareButton
            url={`https://fonolive.com/user-profile/${
              JSON.parse(localStorage.getItem("user")).data.data.id
            }`}
            title={"Please, join and follow me on Fonolive"}
          >
            <WeiboIcon size={32} round={true} />
          </WeiboShareButton>
        </div>
        {!props.hide && (
          <h5
            className="text-dark"
            style={{ fontSize: "1em", marginTop: "5px" }}
          >
            {" "}
            Recent chats
          </h5>
        )}
        <div className="bg-white p-3">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <ul className="list-group w-100">
                {(Array.isArray(state.recentChats) &&
                  state.recentChats.length) === 0 ? (
                  <div className="text-dark">No recent chat</div>
                ) : (
                  state.recentChats.map((item) => {
                    return (
                      <li
                        key={item.receiverId}
                        className="d-flex align-items-center mb-2 curPointer"
                        onClick={() => {
                          seenMsg(item.receiverId);
                          chat(item.senderId);
                        }}
                      >
                        <div className="mr-2 position-relative">
                          {item.user.image == "" ? (
                            <Avatar
                              name={item.user.firstname}
                              maxInitials={2}
                              round={true}
                              size="30"
                            />
                          ) : (
                            <img
                              src={item.user.image}
                              width="47px"
                              height="47px"
                              style={{
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          {item.isOnline && item.user.isOnline ? (
                            <div className="online-show"></div>
                          ) : (
                            <div className="online-show1"></div>
                          )}
                        </div>
                        <div>
                          <div className="fs-6 poppins text-capitalize text-dark">
                            {item.user.firstname}
                          </div>
                          <p className="mb-0 font-13 elisipsStyle">
                            {item.message}
                          </p>
                        </div>
                        {item.seen ? (
                          ""
                        ) : (
                          <div className="ml-auto dot-red fs-6"></div>
                        )}
                      </li>
                    );
                  })
                )}
              </ul>
            </div>
          </div>

          {/* 
			  <div className="tab-pane fade" id="active-friends">
				<div className="row mt-2">
				  <div className="col-md-12 col-sm-12 pt-2">
					<ul className="list-group w-100">
						{(Array.isArray(state.users) && state.users.length)==0 ? <div className="text-dark">No active users</div>  :
						state.users.map((item) => {
							return <>
						 <li className="d-flex align-items-center mb-3">
						<div className="position-relative mr-2">
						  {(Array.isArray(item.image)&& item.image.length)==0 ? <Avatar name={item.firstname} maxInitials={2} round={true} size="50" /> :<Avatar src={item.image[0].url} size="50" round={true} />}
						  <div className="online-show"></div>
						</div>
						<div className="fs-6 poppins mr-1">{item.firstname}</div><div className="fs-6 poppins">{item.lastname}</div>

				
					  </li>
						
							</>
						})
						}
					</ul>
				  </div>
				</div>
			  </div> */}
        </div>
      </div>
      <Toaster />
    </>
  );
}
export default withRouter(RecentChat);
